/*
 * Art-card timelapse hover behavior.
 * Lazy-loads each card's timelapse video on first hover, then plays/pauses.
 * Pairs with snippets/art-timelapse.liquid + assets/art-card.css.
 *
 * Performance: video src is data-src until the user actually hovers, so a grid
 * of 30 artworks downloads zero video bytes on initial page load.
 */
(function () {
  "use strict";

  // Skip on devices without a real hover pointer (mobile/tablet).
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  function initCard(video) {
    if (video.dataset.artBound === "true") return;
    video.dataset.artBound = "true";

    // The hover target is the closest card-gallery wrapper (Horizon cards) or
    // the custom collection card's media wrapper (art-collection.liquid), the
    // whole service card (art-service-card.liquid — its stretched hit button
    // covers the media, so the media itself never gets the pointer), the
    // product page gallery stage (art-product.liquid) or a gallery masonry
    // tile (art-gallery.liquid — there the tile IS the button, so it takes the
    // pointer itself).
    var card = video.closest(".card-gallery, .art-coll__media, .art-scard, .art-pdp__stage, .art-gal__tile");
    if (!card) return;

    var loaded = false;

    function play() {
      if (!loaded) {
        video.src = video.dataset.src;
        loaded = true;
        video.classList.add("is-ready");
      }
      var p = video.play();
      if (p && typeof p.catch === "function") p.catch(function () {});
    }

    function stop() {
      video.pause();
      video.currentTime = 0;
    }

    card.addEventListener("pointerenter", play);
    card.addEventListener("pointerleave", stop);
  }

  function scan(root) {
    (root || document)
      .querySelectorAll("video[data-art-timelapse]")
      .forEach(initCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Re-scan when Shopify section rendering swaps grid content (filters, paging).
  document.addEventListener("shopify:section:load", function (e) {
    scan(e.target);
  });

  // ---- Scroll reveal for .scroll-reveal elements -----------------------
  function revealAll() {
    document
      .querySelectorAll(".scroll-reveal:not(.is-visible)")
      .forEach(function (el) {
        el.classList.remove("pre-reveal");
        el.classList.add("is-visible");
      });
  }

  function initScrollReveal() {
    var els = document.querySelectorAll(
      ".scroll-reveal:not(.is-visible):not(.pre-reveal)",
    );
    if (!els.length) return;

    if (!("IntersectionObserver" in window)) {
      // No observer support: leave everything visible (do not hide).
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.remove("pre-reveal");
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      // threshold 0: reveal as soon as ANY pixel enters. A larger threshold
      // breaks on mobile where sections reflow taller than the viewport, so
      // their intersection ratio can never reach it and they stay hidden.
      { threshold: 0, rootMargin: "0px 0px 80px 0px" },
    );

    var fold = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      // Anything already on screen stays as it is: hiding it only to fade it
      // straight back in delays the first paint of the page (Lighthouse's LCP)
      // and flashes. Only what is still below the fold waits for the scroll.
      if (el.getBoundingClientRect().top < fold) {
        el.classList.add("is-visible");
        return;
      }
      // Hide ONLY now that JS is running and will reveal it. If this script
      // never runs, the element stays visible (no .pre-reveal) — no blank page.
      el.classList.add("pre-reveal");
      io.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScrollReveal);
  } else {
    initScrollReveal();
  }
  document.addEventListener("shopify:section:load", initScrollReveal);

  // Safety net: if anything is still hidden a moment after load (observer
  // never fired, JS error, slow paint), reveal it so content is never lost.
  window.addEventListener("load", function () {
    setTimeout(revealAll, 1200);
  });

  // bfcache restore (mobile back/forward) does NOT re-fire DOMContentLoaded, so
  // re-run the reveal + re-bind hover videos when the page is shown from cache.
  // Without this, navigating back to the homepage leaves every section hidden.
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      scan(document);
      revealAll();
      initScrollReveal();
    }
  });
})();
